import { render } from "./ClientsPrecontracts.vue?vue&type=template&id=6cb85d72&scoped=true"
import script from "./ClientsPrecontracts.vue?vue&type=script&lang=js"
export * from "./ClientsPrecontracts.vue?vue&type=script&lang=js"

import "./ClientsPrecontracts.vue?vue&type=style&index=0&id=6cb85d72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb85d72"]])

export default __exports__